import React from "react";
import PropTypes from "prop-types";

import ChargingPinPublic from "../../../client_customizations/assets/images/icons/Public Stations.svg"
import ChargingPinHighPower from "../../../client_customizations/assets/images/icons/High Power Stations.svg";
import ChargingPinDefault from "../../../client_customizations/assets/images/icons/Other Types of Stations.svg"

const iconSrc = type => {
  switch (type) {
    case "public":
      return ChargingPinPublic;
    case "highPower":
      return ChargingPinHighPower;
    case "private":
    default:
      return ChargingPinDefault;
  }
};

// NOTE: refactored this into its own component to mitigate this:
// https://github.com/google-map-react/google-map-react/issues/583
const ChargingStationsMapMarker = ({
  station,
  ignoreSuperchargerStations,
  selectedStation,
  onClick,
  onMouseOver,
  onMouseLeave
}) => {
  let iconType =
    Number(station.ev_dc_fast_num) && !ignoreSuperchargerStations
      ? "highPower"
      : station.access_code === "public"
        ? "public"
        : "default";

  let imageStyle = {
    width: "25px"
  };
  if (selectedStation && selectedStation.id === station.id) {
    imageStyle.filter = "brightness(85%)";
  }

  const placeStyle = {
    display: "block"
  };

  return (
    <span station={station} style={placeStyle} onClick={onClick} onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}>
      <img src={iconSrc(iconType)} style={imageStyle} alt="" />
    </span>
  );
};

ChargingStationsMapMarker.propTypes = {
  station: PropTypes.shape({
    ev_dc_fast_num: PropTypes.number,
    access_code: PropTypes.string
  }),
  ignoreSuperchargerStations: PropTypes.bool,
  selectedStation: PropTypes.object,
  onClick: PropTypes.func,
  onMouseLeave: PropTypes.func
};

ChargingStationsMapMarker.defaultProps = {
  station: {},
  ignoreSuperchargerStations: false,
  selectedStation: null,
  onClick: () => {},
  onMouseLeave: () => {}
};

export default ChargingStationsMapMarker;
